import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 17h14v2H5zm7-12L5.33 15h13.34z"
}), 'Eject');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Eject.js
// module id = 3318
// module chunks = 2